<app>
  <div id="main-content">
    <div class="logo">
      <a target="{ getLogoTarget() }" href="{ getLogoHref() }">
        <img src="{ getLogoPath() }" alt="logo">
      </a>
    </div>
    <main id="app-router">
      <router base="{ '#' }">
        <route path="" on-before-mount="{ blankPath }" />
        <route path="login">
          <login />
        </route>
        <route path="login\?redirect(.*)">
          <login />
        </route>
        <route path="login\?mail(.*)" on-before-mount="{ props.autoLogin }" />
        <route path="login/staff(.*)">
          <staff-login office-id="{ route.searchParams.get('officeId') }" api-key="{ route.searchParams.get('apiKey') }"
            staff-id="{ route.searchParams.get('staffId') }" password="{ route.searchParams.get('password') }"
            noLogging="{ route.searchParams.get('noLogging') }" />
        </route>
        <route path="notify(.*)">
          <notify register-key="{ route.searchParams.get('key') }"/>
        </route>
        <route path="register(.*)">
          <register r-key="{ route.searchParams.get('key') }" />
        </route>
        <route path="password">
          オーナー様のパスワードを忘れた場合<br>
          ・直接契約の場合：03-6908-6934までご連絡ください。<br>
          ・代理店経由の契約の場合：代理店にお問い合わせください。<br>
          <div style="margin-top: 16px;">
            <a href="#login"><i class="fas fa-angle-double-left"></i>ログイン画面へ戻る</a>
          </div>
          <!-- <password /> -->
        </route>
        <route path="passwordurl(.*)">
          <password pass-key="{ route.searchParams.get('key') }" />
        </route>
        <route path="password/change(.*)">
          <pass-change pass-key="{ route.searchParams.get('key') }" />
        </route>
        <route path="result">
          <result />
        </route>
        <route path="illegalmail(.*)">
          <illegal-mail illegal-key="{ route.searchParams.get('key') }" />
        </route>
        <route path="pcsub">
          <pc-sub />
        </route>
        <route path="pc/check(.*)">
          <pc-check office-id="{ route.searchParams.get('officeId') }"
            api-key="{ route.searchParams.get('apiKey') }" />
        </route>
        <route path="pc/register(.*)">
          <pc-register office-id="{ route.searchParams.get('officeId') }"
            api-key="{ route.searchParams.get('apiKey') }" />
        </route>
        <route path="informowner(.*)">
          <inform-owner />
        </route>
      </router>
    </main>
  </div>
  <kf-loader loader="{ props.loader }" />
  <kf-dialog dialog="{ props.dialog }" on-close="{ props.closeDialog }" />
  <kf-confirm></kf-confirm>
  <kf-alert></kf-alert>
  <script>
    import { Router, Route } from '@riotjs/route';
    import { KfLoader } from '@/common/components/kf-loader';
    import { KfDialog } from '@/common/components/kf-dialog';
    import { KfConfirm } from '@/common/components/kf-confirm';
    import { KfAlert } from '@/common/components/kf-alert';
    import Login from '@/top/login/login';
    import Notify from '@/top/notify/notify';
    import StaffLogin from '@/top/staff-login/staff-login';
    import Register from '@/top/register/register';
    import Password from '@/top/password/password';
    import PassChange from '@/top/password/pass-change';
    import Result from '@/top/result/result';
    import IllegalMail from '@/top/illegal-mail/illegal-mail';
    import PcCheck from '@/top/pc/pc-check';
    import PcSub from '@/top/pc/pc-sub';
    import PcRegister from '@/top/pc/pc-register';
    import InformOwner from '@/top/inform-owner/inform-owner';
    export default {
      base: '#',
      components: {
        Login,
        Notify,
        StaffLogin,
        Register,
        Password,
        PassChange,
        Result,
        IllegalMail,
        PcCheck,
        PcSub,
        PcRegister,
        InformOwner,
        Router,
        Route,
        KfLoader,
        KfDialog,
        KfConfirm,
        KfAlert,
      },
      onBeforeMount() {
        if (location.hash.includes('informowner')) {
          document.title = '予約CTIv2';
        }
      },

      blankPath() {
        location.replace('/top/#login');
      },

      getLogoTarget() {
        return location.hash.includes('informowner') ? '' : '_blank';
      },

      getLogoHref() {
        return location.hash.includes('informowner') ? '' : 'https://cti.fuzoku-fan.jp/';
      },

      getLogoPath() {
        if (location.hash.includes('informowner')) {
          return `${location.protocol}//${location.host}/assets/images/logo-ver2.png`;
        }
        return `${location.protocol}//${location.host}/assets/images/logo.png`;
      }
    };
  </script>
  <style>
    .logo {
      text-align: center;
    }

    .logo img {
      max-width: 100%;
    }

    #main-content {
      padding-top: 34px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      background-color: white;
      margin: 0 auto;
      margin-top: 40px;
      width: 500px;
      max-width: 100%;
    }

    #app-router {
      padding: 26px 32px 42px 32px;
    }
  </style>
</app>